export class Problem {
    id: string;
    tenantId: string;
    startTimestamp: number;
    topicLabel: string;
    topicType: ProblemTopicType;
    description: string;
    elementLabel: string;
    elementId: string;
    elementType: ProblemElementType;
}

export enum ProblemTopicType {
    CONNECTOR = 'CONNECTOR',
    MAPPING = 'MAPPING'
}

export enum ProblemElementType {
    TENANT = 'TENANT',
    CUSTOMER = 'CUSTOMER',
    LOCATION = 'LOCATION',
    THING = 'THING'
}